export const SplatRenderMode = {
    ThreeD: 0,
    TwoD: 1
};
